import React, { useEffect } from 'react'
import SectionHeader from '../../components/SectionHeader'
import BlogCard from '../../components/BlogCard';
import { blogs } from '../../data/blogs';

function BlogPage() {
    useEffect(() => {
        document.title = "Blog";
    }, []);

    return (
        <div className="container py-4">
            <SectionHeader>
                <h2 className="text-center mb-4">Our Blogs</h2>
            </SectionHeader>

            <div className='row g-4'>
                {blogs.map((blog, index) => (
                    <div className='col-12 col-sm-6 col-md-4' key={index}>
                        <BlogCard
                            path={blog.path}
                            url={blog.image_link}
                            title={blog.title}
                            description={blog.description}
                            blog={blog.blog}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default BlogPage;
